var map = {
	"./2kog.svg": 72100,
	"./fsf.svg": 60368,
	"./fuyan.svg": 98473,
	"./iruxu.svg": 75224,
	"./logo.svg": 62570,
	"./other.svg": 54252
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32226;